import React from 'react';
import Icon from '../../../components/AppIcon';

const STEPS = [
  { id: 1, label: 'Empresa', icon: 'Building2', description: 'Datos del taller' },
  { id: 2, label: 'Plan', icon: 'CreditCard', description: 'Suscripción' },
  { id: 3, label: 'Admin', icon: 'UserCheck', description: 'Cuenta de acceso' }
];

const RegistrationStepIndicator = ({ currentStep }) => {
  return (
    <div className="flex items-center justify-center mb-8">
      {STEPS?.map((step, index) => (
        <React.Fragment key={step?.id}>
          <div className="flex flex-col items-center">
            <div
              className={`w-10 h-10 rounded-full flex items-center justify-center transition-all ${
                currentStep > step?.id
                  ? 'bg-green-500 text-white'
                  : currentStep === step?.id
                  ? 'bg-blue-600 text-white shadow-lg shadow-blue-200'
                  : 'bg-gray-100 text-gray-400'
              }`}
            >
              {currentStep > step?.id ? (
                <Icon name="Check" className="w-5 h-5" />
              ) : (
                <Icon name={step?.icon} className="w-5 h-5" />
              )}
            </div>
            <div className="mt-2 text-center">
              <p className={`text-xs font-medium ${
                currentStep >= step?.id ? 'text-gray-900' : 'text-gray-400'
              }`}>{step?.label}</p>
              <p className="text-xs text-gray-400 hidden sm:block">{step?.description}</p>
            </div>
          </div>
          {index < STEPS?.length - 1 && (
            <div
              className={`flex-1 h-0.5 mx-3 mb-6 transition-colors ${
                currentStep > step?.id ? 'bg-green-400' : 'bg-gray-200'
              }`}
            />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default RegistrationStepIndicator;
